import {NgModule} from "@angular/core";
import {TidssoneVelgerKomponentAvhengigheter} from "./skjema/tidssone-velger/tidssone-velger";
import {InternLenkeKomponentAvhengigheter} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/komponenter/intern-lenke-finn/intern-lenke-finn";
import {RiktekstRedigeringInternLenkeVisKomponentAvhengigheter} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/komponenter/intern-lenke-vis/intern-lenke-vis";
import {RiktekstRedigeringLenkeRedigerKomponentAvhengigheter} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/komponenter/lenke-rediger/lenke-rediger";

@NgModule({
    providers: [
        TidssoneVelgerKomponentAvhengigheter,
        InternLenkeKomponentAvhengigheter,
        RiktekstRedigeringInternLenkeVisKomponentAvhengigheter,
        RiktekstRedigeringLenkeRedigerKomponentAvhengigheter
    ]
})
export class DelteKomponenterModul{

}
